// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Avatar, Divider, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';

// assets
import { IconBell } from '@tabler/icons';
import { useSocket } from 'contexts/SocketContext';
import { formatDistanceToNow } from 'date-fns';

// styles
const ListItemWrapper = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const NotificationList = () => {
    const theme = useTheme();
    const { notifications, markAsRead, deleteNotification } = useSocket();

    // Sort by createdAt desc if available
    const sortedNotifications = [...notifications].sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
    });

    if (sortedNotifications.length === 0) {
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <Typography variant="subtitle1">No new notifications</Typography>
            </div>
        );
    }

    return (
        <List
            sx={{
                width: '100%',
                maxWidth: 330,
                py: 0,
                borderRadius: '10px',
                [theme.breakpoints.down('md')]: {
                    maxWidth: 300
                },
                '& .MuiListItemSecondaryAction-root': {
                    top: 22
                },
                '& .MuiDivider-root': {
                    my: 0
                },
                '& .list-container': {
                    pl: 7
                }
            }}
        >
            {sortedNotifications.map((notification, index) => (
                <div key={notification._id || notification.id || index}>
                    <ListItemWrapper
                        onClick={() => markAsRead(notification._id || notification.id)}
                        sx={{
                            backgroundColor: notification.read || notification.status === 'read' ? 'inherit' : theme.palette.action.hover
                        }}
                    >
                        <ListItem alignItems="center">
                            <ListItemAvatar>
                                <Avatar
                                    sx={{
                                        color: theme.palette.primary.main,
                                        bgcolor: theme.palette.primary.light
                                    }}
                                >
                                    <IconBell stroke={1.5} size="1.3rem" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={<Typography variant="subtitle1">{notification.title || 'Notification'}</Typography>} />
                            <ListItemSecondaryAction>
                                <Grid container justifyContent="flex-end">
                                    <Grid item xs={12}>
                                        <Typography variant="caption" display="block" gutterBottom>
                                            {notification.createdAt
                                                ? formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true })
                                                : 'Just now'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Grid container direction="column" className="list-container">
                            <Grid item xs={12} sx={{ pb: 2 }}>
                                <Typography variant="subtitle2">{notification.message || notification.body}</Typography>
                            </Grid>
                        </Grid>
                    </ListItemWrapper>
                    {index < sortedNotifications.length - 1 && <Divider />}
                </div>
            ))}
        </List>
    );
};

export default NotificationList;
